import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import CurrencyList from "./curencyList";
import { getCurrencyApi } from "../../../api/currency";
import { AddEditCurrency } from "./AddEditCurrency";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Currency = () => {
  const [openCurrency, setOpenCurrency] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedCurrency, setPaginatedCurrency] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getCurrency({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedCurrency(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getCurrency({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedCurrency(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getCurrency({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedCurrency(res.data);
    });
  };

  const getCurrency = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await CurrencyMutation(params);
  };

  const { mutateAsync: CurrencyMutation, isLoading: isCurrencyLoading } =
    useMutation("currencies", getCurrencyApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>

          <AddButton onClick={() => setOpenCurrency(true)} />
        </Col>
        <Col span={24} className="">
          <CurrencyList
            tableKey={tableKey}
            page={page}
            setPage={setPage}
            filter={filter}
            search={search}
            paginatedCurrency={paginatedCurrency}
            isCurrencyLoading={isCurrencyLoading}
            setPaginatedCurrency={setPaginatedCurrency}
            CurrencyMutation={CurrencyMutation}
          />
        </Col>
      </Row>
      {openCurrency && (
        <AddEditCurrency
          openCurrency={openCurrency}
          setOpenCurrency={setOpenCurrency}
          setPaginatedCurrency={setPaginatedCurrency}
          CurrencyMutation={CurrencyMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}
    </>
  );
};

export default Currency;
